import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";

// 路由拦截
import "@/router/interceptors";

Vue.config.productionTip = false;

//引入ElementUI
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
Vue.use(ElementUI);

// AES解密
import { aes128Decrypt } from "@/utils/aes128.js";
Vue.prototype.$aes128Decrypt = aes128Decrypt;

import "./assets/font/iconfont.css";

// 引入移动端样式
import "./style/mobile.scss";

// 引入调试样式（解决Info页面显示异常）
import "./style/debug.scss";

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
